/**
 * StatTile — a labelled money figure used in the session-stats grid. Pure presentation.
 */
import type { ReactNode } from "react";
import { Money } from "./Money";

export interface StatTileProps {
  label: ReactNode;
  centimes: number | null | undefined;
  /** Optional secondary line (e.g. a count). */
  sub?: ReactNode;
  strong?: boolean | undefined;
}

export function StatTile({ label, centimes, sub, strong }: StatTileProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--nv-s-1)",
        padding: "var(--nv-s-3)",
        borderRadius: "var(--nv-r-md)",
        background: "var(--nv-surface-2)",
        border: "1px solid var(--nv-line-faint)",
      }}
    >
      <span style={{ fontSize: "var(--nv-fs-label)", color: "var(--nv-slate)" }}>{label}</span>
      <span style={{ fontSize: "var(--nv-fs-title)" }}>
        <Money centimes={centimes} strong={strong} />
      </span>
      {sub != null && (
        <span style={{ fontSize: "var(--nv-fs-caption)", color: "var(--nv-steel)" }}>{sub}</span>
      )}
    </div>
  );
}
